import { render, staticRenderFns } from "./MembroForm.vue?vue&type=template&id=042039c5&scoped=true&"
import script from "./MembroForm.vue?vue&type=script&lang=js&"
export * from "./MembroForm.vue?vue&type=script&lang=js&"
import style0 from "./MembroForm.vue?vue&type=style&index=0&id=042039c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042039c5",
  null
  
)

export default component.exports